import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogContentContainerComponent } from './dialog-content-container.component';

@NgModule({
  declarations: [DialogContentContainerComponent],
  imports: [CommonModule],
  exports: [DialogContentContainerComponent],
})
export class DialogContentContainerModule {}
